module.exports = __webpack_public_path__ + "debae62da198b13748d0780a1caa0dc9.gif";